"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableStateProps = exports.TableRowProps = exports.TableHeaderGroupProps = exports.TableColumnProps = exports.TableColumnDefinitionProps = exports.TableColumnDefinitionArrayProp = exports.TableCellProps = exports.RowsArrayProp = exports.HeaderGroupsArrayProp = exports.ColumnsArrayProp = exports.ColumnSortProps = exports.ColumnProps = exports.ColumnGroupProps = void 0;
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ColumnProps = exports.ColumnProps = {
  accessor: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  id: _propTypes.default.string,
  columns: _propTypes.default.arrayOf(_propTypes.default.any),
  Aggregated: _propTypes.default.func,
  aggregate: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  filter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.oneOf(['includes', 'equals', 'between', 'fuzzyText', 'greaterThan', 'lessThan', 'text'])]),
  Filter: _propTypes.default.func,
  Header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.element]),
  Footer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.element]),
  Cell: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  width: _propTypes.default.number,
  minWidth: _propTypes.default.number,
  maxWidth: _propTypes.default.number
};
const ColumnGroupProps = exports.ColumnGroupProps = {
  canGroupBy: _propTypes.default.bool,
  isGrouped: _propTypes.default.bool,
  getGroupByToggleProps: _propTypes.default.func
};
const ColumnSortProps = exports.ColumnSortProps = {
  isSorted: _propTypes.default.bool,
  isSortedDesc: _propTypes.default.bool,
  render: _propTypes.default.func,
  getSortByToggleProps: _propTypes.default.func
};
const TableColumnDefinitionProps = exports.TableColumnDefinitionProps = _objectSpread(_objectSpread({}, ColumnProps), {}, {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape(ColumnProps))
});
const TableColumnDefinitionArrayProp = exports.TableColumnDefinitionArrayProp = _propTypes.default.arrayOf(_propTypes.default.shape(TableColumnDefinitionProps));
const TableColumnProps = exports.TableColumnProps = {
  id: _propTypes.default.string,
  isVisible: _propTypes.default.bool,
  render: _propTypes.default.func,
  totalLeft: _propTypes.default.number,
  totalWidth: _propTypes.default.number,
  getHeaderProps: _propTypes.default.func,
  getFooterProps: _propTypes.default.func,
  toggleHidden: _propTypes.default.func,
  getToggleHiddenProps: _propTypes.default.func,
  inputType: _propTypes.default.string,
  dataType: _propTypes.default.string
};
const TableHeaderGroupProps = exports.TableHeaderGroupProps = {
  headers: _propTypes.default.arrayOf(_propTypes.default.shape(ColumnProps)),
  getHeaderGroupProps: _propTypes.default.func,
  getFooterGroupProps: _propTypes.default.func,
  hasSelectorColumn: _propTypes.default.bool,
  enableGrouping: _propTypes.default.bool,
  isEditable: _propTypes.default.bool,
  inlineEditing: _propTypes.default.bool
};
const rowPropTypes = {
  cells: _propTypes.default.arrayOf(_propTypes.default.any),
  allCells: _propTypes.default.arrayOf(_propTypes.default.any),
  values: _propTypes.default.any,
  getRowProps: _propTypes.default.func,
  index: _propTypes.default.number,
  original: _propTypes.default.any,
  isExpanded: _propTypes.default.bool
};
const TableCellProps = exports.TableCellProps = {
  column: _propTypes.default.shape(TableColumnProps),
  row: _propTypes.default.shape(rowPropTypes),
  value: _propTypes.default.any,
  isGrouped: _propTypes.default.bool,
  isAggregated: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  isPlaceholder: _propTypes.default.bool,
  getCellProps: _propTypes.default.func,
  render: _propTypes.default.func
};
const TableRowProps = exports.TableRowProps = _objectSpread(_objectSpread({}, rowPropTypes), {}, {
  subRows: _propTypes.default.arrayOf(_propTypes.default.shape(rowPropTypes)),
  getToggleRowExpandedProps: _propTypes.default.func,
  state: _propTypes.default.any
});
const ColumnsArrayProp = exports.ColumnsArrayProp = _propTypes.default.arrayOf(_propTypes.default.shape(ColumnProps));
const HeaderGroupsArrayProp = exports.HeaderGroupsArrayProp = _propTypes.default.arrayOf(_propTypes.default.shape(TableHeaderGroupProps));
const RowsArrayProp = exports.RowsArrayProp = _propTypes.default.arrayOf(_propTypes.default.shape(TableRowProps));
const TableStateProps = exports.TableStateProps = {
  columns: ColumnsArrayProp,
  allColumns: ColumnsArrayProp,
  visibleColumns: ColumnsArrayProp,
  getTableProps: _propTypes.default.func,
  getTableBodyProps: _propTypes.default.func,
  headerGroups: HeaderGroupsArrayProp,
  footerGroups: HeaderGroupsArrayProp,
  headers: ColumnsArrayProp,
  flatHeaders: ColumnsArrayProp,
  rows: RowsArrayProp,
  flatRows: RowsArrayProp,
  prepareRow: _propTypes.default.func,
  totalColumnsWidth: _propTypes.default.number,
  toggleHideColumn: _propTypes.default.func,
  toggleHideAllColumns: _propTypes.default.func,
  getToggleHideAllColumnsProps: _propTypes.default.func,
  setHiddenColumns: _propTypes.default.func,
  page: RowsArrayProp,
  canPreviousPage: _propTypes.default.bool,
  canNextPage: _propTypes.default.bool,
  pageOptions: _propTypes.default.arrayOf(_propTypes.default.number),
  pageCount: _propTypes.default.number,
  gotoPage: _propTypes.default.func,
  nextPage: _propTypes.default.func,
  previousPage: _propTypes.default.func,
  setPageSize: _propTypes.default.func,
  setRowState: _propTypes.default.func,
  state: _propTypes.default.shape({
    pageIndex: _propTypes.default.number,
    pageSize: _propTypes.default.number,
    sortBy: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      desc: _propTypes.default.bool
    })),
    groupBy: _propTypes.default.arrayOf(_propTypes.default.string),
    expanded: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
    filters: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      // eslint-disable-next-line react/forbid-prop-types
      value: _propTypes.default.any
    })),
    selectedRowIds: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.string)])
  })
};
var _default = exports.default = {
  ColumnProps,
  ColumnGroupProps,
  ColumnSortProps,
  TableColumnDefinitionProps,
  TableColumnProps,
  TableHeaderGroupProps,
  TableCellProps,
  TableRowProps,
  TableStateProps
};